import React from "react";
import RootWrapper from "./src/RootWrapper";

// NOTE: custom styles are NOT imported here. Gatsby would inline them at the TOP of
// <head>, before the theme CSS, causing custom overrides to lose the cascade. Instead
// custom.scss is compiled to /assets/css/custom.css (onPreBootstrap) and linked LAST
// in gatsby-ssr.js, matching the original site's load order.

export const wrapRootElement = ({ element }) => {
  return <RootWrapper element={element} />;
};

// Google Analytics page view tracking on client-side route changes
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", process.env.GATSBY_GOOGLE_ANALYTICS, {
      page_path: location.pathname,
    });
  }
};
